import React, { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon, MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import { Bars3Icon, BellIcon } from '@heroicons/react/24/outline'
import useToken from '../utils/useToken'
import { getProfile } from '../api/coll'
import logo from '../assets/images/logo.png'
import { useSelector } from 'react-redux'
import { Select } from 'antd'
import { Enums } from '@/utils/settings'
import { store } from '@/store/index'

const userNavigation = [
  { name: '登出', href: '#' }
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Header({ setSidebarOpen }) {
  const { removeToken } = useToken()
  const profile = useSelector(state => state.UserReducer)
  const { entryGroup } = useSelector(state => state.HeaderReducer)

  const selectGroup = (v) => {
    if (v === 'all' || v === undefined || v === 0) {
      store.dispatch({
        type: 'set_entryGroup',
        payload: undefined
      })
    } else {
      store.dispatch({
        type: 'set_entryGroup',
        payload: v
      })
    }
  }

  const GroupSelectProps = {
    hidden: false,
    id: 'group',
    name: 'group',
    placeholder: '请选择分组',
    label: '分组',
    options: profile.groupArr || Enums.entry_groups,
    type: 'select',
    allowClear: true,
    defaultValue: entryGroup,
    onChange: selectGroup
  }

  return (
    <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
      <button className="-m-2.5 p-2.5 text-gray-700 lg:hidden" onClick={() => setSidebarOpen(true)} type="button">
        <Bars3Icon aria-hidden="true" className="h-6 w-6" />
      </button>

      {/* Separator */}
      <div aria-hidden="true" className="h-6 w-px bg-gray-900/10 lg:hidden" />

      <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
        <div className="flex flex-1" />
        <div className="flex items-center justify-end space-x-2">
          <Select className="w-[120px]" {...GroupSelectProps} />
        </div>
        <div className="flex items-center gap-x-4 lg:gap-x-6">

          {/* Separator */}
          <div aria-hidden="true" className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10" />

          {/* Profile dropdown */}
          <Menu as="div" className="relative">
            <Menu.Button className="-m-1.5 flex items-center p-1.5">
              <img
                alt=""
                className="h-8 w-8 rounded-full bg-gray-50 object-cover"
                src={profile.logourl ? profile.logourl : profile.avatarurl}
              />
              <span className="hidden lg:flex lg:items-center">
                <span aria-hidden="true" className="ml-4 text-sm font-semibold leading-6 text-gray-900">
                  {profile.fullname}
                </span>
                <ChevronDownIcon aria-hidden="true" className="ml-2 h-5 w-5 text-gray-400" />
              </span>
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                {userNavigation.map((item) => (
                  <Menu.Item key={item.name}>
                    {({ active }) => (
                      <a
                        className={classNames(
                                active ? 'bg-gray-50' : '',
                                'block px-3 py-1 text-sm leading-6 text-gray-900'
                        )}
                        href={item.href}
                        onClick={() => removeToken()}
                      >
                        {item.name}
                      </a>
                    )}
                  </Menu.Item>
                ))}
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>
    </div>
  )
}
